import { filter, first, length, map, merge } from "@pdfking/rfunc"
import { Void } from "@pdfking/tfunc"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import { make_absolute_url } from "@pdfking/workflow/utils/urlutilities"
import { defineComponent, withModifiers } from "vue"
import selector from "../../dom/selector"
import close from "../../mixins/Close"
import freeze from "../../mixins/Freeze"
import keyboard from "../../state/keyboard"
import navigate from "../navigate"
import { SLIDESHOW_VIEW } from "../urls"

export default defineComponent({
  computed: merge(
    proxy(keyboard, {
      ARROW_DOWN: "down_pressed",
      ARROW_LEFT: "left_pressed",
      ARROW_RIGHT: "right_pressed",
      ARROW_UP: "up_pressed",
    }),

    {
      current() {
        // @ts-expect-error - Vue prop
        const target = make_absolute_url(this.selected)
        return (
          first(filter((e: any) => e.src == target, this.images)) ||
          first(this.images)
        )
      },
      current_index() {
        // @ts-expect-error - Vue computed returns array
        return (this.images as { src: string }[]).indexOf(this.current)
      },
      images() {
        // @ts-expect-error - Vue prop
        return this.selector
          ? map(
              (e: HTMLImageElement) => ({
                description: e.alt,
                src: make_absolute_url(
                  e.getAttribute("data-slide-src") || e.src
                ),
                title: e.title,
              }),
              // @ts-expect-error - Vue prop
              selector(this.selector)
            )
          : []
      },
      translations: () => make_translations(["actions"]),
    }
  ),
  data() {
    return {
      toggled_class: "modal-body",
    }
  },
  methods: {
    goto(position: number) {
      let next = position

      if (next + 1 > length(this.images)) next = 0
      if (next < 0) next = length(this.images) - 1

      navigate(SLIDESHOW_VIEW, {
        selected: this.images[next].src,
        selector: this.selector,
      })
    },
    next() {
      this.goto(this.current_index + 1)
    },
    prev() {
      this.goto(this.current_index - 1)
    },
  },
  mixins: [close, freeze],
  props: ["selector", "selected"] as const,
  render() {
    return (
      <div
        class="modal fade show opacity-100 modal p-3 d-flex align-items-center justify-content-center"
        onClick={this.close}
      >
        <div
          class="modal-dialog modal-fullscreen bg-white rounded"
          style="height: calc(100vh - 50px); width: calc(100vw - 50px)"
          onClick={withModifiers(Void, ["stop"])}
        >
          <div class="modal-content position-relative rounded">
            <div class="carousel carousel-dark slide h-100 rounded">
              <div class="carousel-inner w-100 h-100 rounded">
                <img
                  class="carousel-item active img-cover w-100 h-100 rounded"
                  src={this.current.src}
                  title={this.current.title}
                />
              </div>

              <div class="carousel-indicators">
                {this.images.map((image: any, index: number) => (
                  <button
                    key={index}
                    class={{ active: image.src == this.current.src }}
                    data-bs-target
                    title={image.title}
                    type="button"
                    onClick={() => this.goto(index)}
                  ></button>
                ))}
              </div>

              <button
                class="carousel-control-prev"
                type="button"
                onClick={withModifiers(() => this.prev(), ["prevent"])}
              >
                <span class="carousel-control-prev-icon"></span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                onClick={withModifiers(() => this.next(), ["prevent"])}
              >
                <span class="carousel-control-next-icon"></span>
              </button>
            </div>

            <button
              class="btn-close position-absolute top-0 end-0 mx-4 my-4 p-2 rounded-circle border bg-light z-3"
              title={this.translations.actions.CLOSE}
              type="button"
              onClick={this.close}
            />
          </div>
        </div>
      </div>
    )
  },

  watch: {
    down_pressed(v: boolean) {
      if (v) this.next()
    },
    left_pressed(v: boolean) {
      if (v) this.prev()
    },
    right_pressed(v: boolean) {
      if (v) this.next()
    },
    up_pressed(v: boolean) {
      if (v) this.prev()
    },
  },
})
